import firebase from "firebase";

var firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyDBwWrF0LVZzSo0TSRTFa1Xsw4HtrDX-Ww",
  authDomain: "blood-donors-58841.firebaseapp.com",
  projectId: "blood-donors-58841",
  storageBucket: "blood-donors-58841.appspot.com",
  messagingSenderId: "97832454555",
  appId: "1:97832454555:web:546be1dc9cd4d08a1cb93e",
});

var db = firebaseApp.firestore();

export { db };
